module.exports = __webpack_public_path__ + "static/media/upload_icon.73d4f504.svg";